var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container sub_wrap sub_bg_type1",
    attrs: {
      "id": "container"
    }
  }, [_c('article', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [_c('Breadcrumb'), _c('WPageWrapper', {
    attrs: {
      "first-fetch-data-callback": _vm.fetchData
    }
  }, [_c('div', {
    staticClass: "sub_section_wrap book_literary_intro"
  }, [_c('WTitle', {
    attrs: {
      "tag-name": "h3"
    }
  }, [_vm._v("연재")]), _c('section', {
    staticClass: "page_section sec_literary_intro"
  }, [_c('div', {
    staticClass: "page_section_inner"
  }, [_vm.seriesInfo ? _c('LiteraryInfo', {
    attrs: {
      "book-detail": _vm.seriesInfo
    }
  }) : _vm._e()], 1)]), _c('section', {
    staticClass: "page_section sec_literary_list"
  }, [_c('Episodes', {
    attrs: {
      "series-id": _vm.seriesId,
      "episode-list": _vm.episodeList
    }
  })], 1)], 1)])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }